import { createFileRoute } from '@tanstack/react-router'
import ExportSinglePlanModal from '../../../../../../../containers/plan-menu/components/export-plan-modals/export-single-plan'
import { plansContextSearchSchema } from '../../search-schemas'

export const Route = createFileRoute(
  '/_authenticated/project/$projectId/_plans/exportPlan/$planId/'
)({
  validateSearch: plansContextSearchSchema,
  component: RouteComponent
})

function RouteComponent() {
  return <ExportSinglePlanModal />
}
